import React from 'react';
import InstitutionLogo from "./InstitutionLogo.jsx";
import PendingText from "react/components/PendingText";

export default function TransactionBankInformation({ transaction, showPending = false }) {
	if(!transaction) {
		return null;
	}
	const plaidTransaction = transaction.getPlaidTransaction();
	if(!plaidTransaction) {
		return null;
	}
	const account = plaidTransaction.account;
	if(!account) {
		return null;
	}

	const displayName = account.getDisplayName();
	const names = [];
	if(account?.institution.name) {
		names.push(account.institution.name);
	}
	if(displayName) {
		names.push(displayName);
	}

	return (
		<div className='bank_information_holder'
		     title={names.join(' ')}
		>
			<span className='bank_information'>
				<InstitutionLogo
					institution={account?.institution}
				/>
				{!!account.institution &&
				<span className='institution_name'>{account.institution.name}</span>
				}
				{!!displayName &&
				<span>{' '}
					<span
						className='account_name'>
						{displayName}
					</span>
				</span>
				}
				{!account.is_active &&
					<span className='disabled'>{' '}Disabled</span>
				}
				{showPending && !!plaidTransaction.pending && <PendingText />}
			</span>
		</div>
	);
}